function getRowKey(record, index, rowKey) {
  const recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
  return recordKey === undefined ? index : recordKey;
}

export { getRowKey };
